module.exports = __webpack_public_path__ + "static/media/loader.1ab818e2.svg";